export type EquipmentGroupAssignmentRow = {
  id: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  equipmentId: string;
  groupId: string;
  propelOrgId: string;
};

export class EquipmentGroupAssignment {
  id: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  equipmentId: string;
  groupId: string;
  propelOrgId: string;

  constructor(params: EquipmentGroupAssignmentRow) {
    this.id = params.id;
    this.createdAt = params.createdAt;
    this.updatedAt = params.updatedAt;
    this.equipmentId = params.equipmentId;
    this.groupId = params.groupId;
    this.propelOrgId = params.propelOrgId;
  }
}
